import React, { FC } from "react";
import { Address } from "@app/provider/profile";
import MobilePhlebotomyAddressFormActions from "./mobilePhlebotomyAddressFormActions";
import { MpxAddressFormStandalone } from "@app/components/forms/mpxAddressForm";

import "./mobilePhlebotomyAddressForm.scss";

interface Props {
  handleSubmit: (address: Partial<Address>) => void;
  handleCancel: () => void;
  isKitShippingStep?: boolean;
}

const MobilePhlebotomyAddressForm: FC<Props> = ({
  handleSubmit,
  handleCancel,
  isKitShippingStep,
}) => {
  return (
    <MpxAddressFormStandalone
      onSubmit={handleSubmit}
      actions={
        <MobilePhlebotomyAddressFormActions
          handleCancel={handleCancel}
          isKitShippingStep={isKitShippingStep}
        />
      }
    />
  );
};

export default MobilePhlebotomyAddressForm;
